import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=0546192b&scoped=true&"
import script from "./Sidebar.vue?vue&type=script&lang=js&"
export * from "./Sidebar.vue?vue&type=script&lang=js&"
import style0 from "./Sidebar.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Sidebar.vue?vue&type=style&index=1&id=0546192b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0546192b",
  null
  
)

export default component.exports